import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencySymbol', standalone: true })
export class CurrencySymbolPipe implements PipeTransform {
  transform(currencySymbol?: { symbol?: string; code?: string } | string): {
    symbol: string;
    isSar: boolean;
  } {
    if (!currencySymbol) return { symbol: '', isSar: false };

    if (typeof currencySymbol === 'string') {
      const isSar = currencySymbol === 'ر.س' || currencySymbol === 'SAR';
      return {
        symbol: isSar ? '\uE900' : currencySymbol,
        isSar,
      };
    }

    const isSar =
      currencySymbol.symbol === 'ر.س' ||
      currencySymbol.symbol === 'SAR' ||
      currencySymbol.code === 'SAR';

    return {
      symbol: isSar ? '\uE900' : currencySymbol.symbol || '',
      isSar,
    };
  }
}
